import { render, staticRenderFns } from "./MainGetStarted.vue?vue&type=template&id=55ec73f4&"
import script from "./MainGetStarted.vue?vue&type=script&lang=js&"
export * from "./MainGetStarted.vue?vue&type=script&lang=js&"
import style0 from "./MainGetStarted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports